<template>
  <span>
    <span v-if="event.eventtime_override">
      {{ event.eventtime_override }}
    </span>
    <span v-else-if="event.eventtime" class="capitalize">
      {{ formatDate(getEventtime(event), { locale: $i18n.locale, showTime }) }}
    </span>
  </span>
</template>

<script setup lang="ts">
  import type { EventCheckoutData } from '@/types';
  import { getEventtime } from '@/utils/eventCheckoutDataUtil';
  import { formatDate } from '@/utils/formatDate';

  defineProps<{
    event: EventCheckoutData;
    showTime?: boolean;
  }>();
</script>
